import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
    selector: 'app-market-comparison',
    templateUrl: './market-comparison.component.html',
    styleUrls: ['./market-comparison.component.scss'],
    standalone: false
})
export class MarketComparisonComponent implements OnInit {
  @Input() name!: string
  @Input() ticker!: string
  @Input() data!: any[]
  @Input() indexData!: any[]
  indexName: string = '';
  constructor(private meta: Meta, private title: Title, private router: Router) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['indexData'] && changes['indexData'].currentValue) {

      // Extract the index name from the first entry
      if (Array.isArray(this.indexData) && this.indexData.length > 0) {
        const indexItem = this.indexData[0].find((item: any) => item.label === 'index_name');
        this.indexName = indexItem ? indexItem.value : '';
        this.updateMetaTags();
      }
    }
  }
  hasValidIndexData(): boolean {
    if (!this.indexName || !Array.isArray(this.indexData) || this.indexData.length === 0) {
      return false;
    }

    // Flatten and check if at least one period has valid data
    const flatData = this.indexData.reduce((acc, val) => acc.concat(val), []);
    return ['pc_ytd', 'pc_1y', 'pc_3y', 'pc_5y'].some(label =>
      flatData.some((entry: { label: string; value: number | string }) => entry.label === label && entry.value !== 'N/A')
    );
  }
  getPeriodLabel(period: string): string {
    const labels: { [key: string]: string } = {
      'pc_ytd': 'YTD Performance',
      'pc_1y': '1Y Performance',
      'pc_3y': '3Y Performance',
      'pc_5y': '5Y Performance'
    };
    return labels[period] || 'Performance';
  }


  getValueByLabel(label: string): number | string {
    const item = this.data.find((entry: { label: string; value: number | string }) => entry.label === label);
    return item ? item.value : 'N/A';
  }

  private updateMetaTags(): void {
    if (!this.name || !this.ticker || !this.indexName) {
      return;
    }

    // const pageTitle = `${this.name} (${this.ticker}) vs ${this.indexName} - Performance Comparison`;
    // const pageDescription = `${this.name} (${this.ticker}) is analyzed for Shariah compliance. Compare its performance against the ${this.indexName} to understand its market standing.`;
    const currentUrl = this.router.url; // Get the current URL dynamically

    // this.title.setTitle(pageTitle);

    // this.meta.updateTag({ name: 'description', content: pageDescription });
    this.meta.updateTag({ name: 'keywords', content: `${this.name}, ${this.ticker}, ${this.indexName}, stock market, shariah compliance, stock performance` });

    // Open Graph Meta Tags
    // this.meta.updateTag({ property: 'og:title', content: pageTitle });
    // this.meta.updateTag({ property: 'og:description', content: pageDescription });
    this.meta.updateTag({ property: 'og:url', content: `https://musaffa.com${currentUrl}` });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:site_name', content: 'Musaffa' });
  }



  getValueByLabel2(label: string): number | string {
    // Flatten the nested array before searching
    const flatData = this.indexData.reduce((acc, val) => acc.concat(val), []); // Alternative to flat()
    const item = flatData.find((entry: { label: string; value: number | string }) => entry.label === label);
    return item ? item.value : 'N/A';
  }




  calculateDifference(label: string): { difference: string, higherValue: number } {
    const value1 = this.getValueByLabel(label);
    const value2 = this.getValueByLabel2(label);

    // Ensure both values are numbers before calculating
    if (typeof value1 === 'number' && typeof value2 === 'number') {
      const diff = value1 - value2;
      return {
        difference: Math.abs(diff).toFixed(2), // Absolute difference formatted to 2 decimal places
        higherValue: diff // Original difference to determine which performed better
      };
    }

    return { difference: 'N/A', higherValue: 0 }; // If values are not numbers
  }

  isValueNegative(label: string, useSecond: boolean = false): boolean {
    const val = useSecond ? this.getValueByLabel2(label) : this.getValueByLabel(label);
    return typeof val === 'number' && val < 0;
  }

  isValuePositive(label: string, useSecond: boolean = false): boolean {
    const val = useSecond ? this.getValueByLabel2(label) : this.getValueByLabel(label);
    return typeof val === 'number' && val >= 0;
  }

}
